let presets = [
	{
		name: "Light Mode",
		type: "Style",
		attributes: [
			{ key: "data-modal-color", value: "#FFFFFF" },
			{ key: "data-text-color", value: "#333333" },
		],
	},
	{
		name: "Dark Mode",
		type: "Style",
		attributes: [
			{ key: "data-modal-color", value: "#333333" },
			{ key: "data-text-color", value: "#eeeeee" },
		],
	},
];

export default presets;
